import { useEffect, useRef, useState } from "react";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import { apiCreatePltCommon } from "../../../api/master";
import uomSchema from "../../../validations/UOM";

function UOMAdd(props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [shownew, setShownew] = useState(false);
  const inputRef = useRef(null);

  const uomFormik = useFormik({
    initialValues: {
      uom_name: "",
    },
    validationSchema: uomSchema.validateUOM(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setIsSubmit(true);
      const payload = {
        plt_name: "item_uom",
        uom_name: values.uom_name,
        is_active: 1,
      };
      await apiCreatePltCommon(payload)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          setShownew(true);
          props.list();
        })
        .catch((err) => {
          setError(err.response?.data?.data?.message || err.message);
          setSuccess("");
        })
        .finally(() => {
          setIsSubmit(false);
        });
    },
    onReset: async (values) => {
      uomFormik.resetForm();
      setShownew(false);
      setSuccess("");
      setError("");
    },
  });

  useEffect(() => {
    if (!shownew && inputRef.current) {
      inputRef.current.focus();
    }
  }, [shownew]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccess("");
      setError("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [success, error]);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Add UOM
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={uomFormik.handleSubmit}
          onReset={uomFormik.handleReset}
          autoComplete="off"
        >
          <div className="col-md-12">
            <label htmlFor="uom_name">
              UOM Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="uom_name"
              ref={inputRef}
              {...uomFormik.getFieldProps("uom_name")}
            />
            {uomFormik.errors.uom_name && !shownew && (
              <div className="text-danger small">{uomFormik.errors.uom_name}</div>
            )}
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "end",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="reset"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  type="reset"
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                    marginLeft: "10px",
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  className="btn btn-primary"
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                    marginLeft: "10px",
                    background: "#4263eb",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    padding: "0 20px",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default UOMAdd;
